import { createContext } from 'react';

import { useNewbuildingBrokerWidgetAPI } from './useNewbuildingBrokerWidgetAPI';

type TValue = ReturnType<typeof useNewbuildingBrokerWidgetAPI>['openWidget'];

export const NewbuildingBrokerWidgetContext = createContext<TValue>(() => Promise.resolve());
